import { List } from 'immutable'
import { root as endUserRoot } from '../selectors'
import * as constants from './constants'

export const root = (state) => endUserRoot(state).get('timeline')

export const status = (state) => root(state).get('status')
export const events = (state) => root(state).getIn(['events', 'data'], List())
export const cursor = (state) => root(state).getIn(['events', 'cursor'])
export const hasNext = (state) => root(state).getIn(['events', 'hasNext'])

export const isLoading = (state) => status(state) === constants.FETCH_TIMELINE_EVENTS_FOR_END_USER_PENDING
export const isLoadingMore = (state) => status(state) === constants.LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_PENDING



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/timeline/selectors.js